import type { ServiceStatusData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import produce from 'immer';

import type { PageData } from '../../types/common';
import { handleSingleRecordUpdate, isSingleRecordUpdate } from '../../utils/serviceStatus';

export const updateServiceStatusData = (
  state: PageData,
  { response }: { response: ServiceStatusData[] }
) =>
  produce(state, (draft) => {
    if (isSingleRecordUpdate(response)) {
      draft.serviceStatusData = handleSingleRecordUpdate(draft.serviceStatusData, response[0]);
    } else {
      draft.serviceStatusData = response;
    }
  });

export const clearServiceStatus = (state: PageData) =>
  produce(state, (draft) => {
    if (draft.serviceStatusData) {
      draft.serviceStatusData = [];
    }
  });
